module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_6.607539bc.jpeg";